var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserMultiple(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.952 20H19.4422C20.592 20 21.5066 19.4761 22.3278 18.7436C24.4139 16.8826 19.51 15 17.8359 15M15.8359 5.06877C16.063 5.02373 16.2988 5 16.5407 5C18.3606 5 19.8359 6.34315 19.8359 8C19.8359 9.65685 18.3606 11 16.5407 11C16.2988 11 16.063 10.9763 15.8359 10.9312",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.81725 16.1112C3.63828 16.743 0.547076 18.0331 2.42982 19.6474C3.34953 20.436 4.37385 21 5.66166 21H13.0102C14.298 21 15.3223 20.436 16.242 19.6474C18.1248 18.0331 15.0336 16.743 13.8546 16.1112C11.0899 14.6296 7.58193 14.6296 4.81725 16.1112Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3359 7.5C13.3359 9.70914 11.545 11.5 9.33594 11.5C7.1268 11.5 5.33594 9.70914 5.33594 7.5C5.33594 5.29086 7.1268 3.5 9.33594 3.5C11.545 3.5 13.3359 5.29086 13.3359 7.5Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserMultiple);
export default __webpack_public_path__ + "static/media/user-multiple.d5748af63aac99cd80ea030aa0d7fda4.svg";
export { ForwardRef as ReactComponent };